import { exists, LimitCheckMethod } from '@/api'

export interface ConditionReserveLimit {
  id: number
  limitCheck: boolean
  limitCheckMethod: LimitCheckMethod
  numberOfLimit: number
  revision: number
}

export const defaultConditionReserveLimit = (): ConditionReserveLimit => ({
  id: 0,
  limitCheck: false,
  limitCheckMethod: LimitCheckMethod.All,
  numberOfLimit: 0,
  revision: 0
})

export function ConditionReserveLimitFromJSON(
  json: any
): ConditionReserveLimit {
  return {
    id: exists(json, 'id') ? json.id : 0,
    limitCheck: exists(json, 'limit_check') ? json.limit_check : false,
    limitCheckMethod: exists(json, 'limit_check_method')
      ? json.limit_check_method
      : LimitCheckMethod.All,
    numberOfLimit: exists(json, 'number_of_limit') ? json.number_of_limit : 0,
    revision: exists(json, 'revision') ? json.revision : 0
  }
}
